import * as React from 'react';
import { Button, HeartStroke16, Heart16 } from '@cian/ui-kit';
import * as styles from './FavoriteButton.css';
export var FavoriteButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var isFavorite = _ref.isFavorite,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement(Button, {
    ref: ref,
    onClick: onClick,
    size: "XS",
    beforeIcon: isFavorite ? /*#__PURE__*/React.createElement(Heart16, null) : /*#__PURE__*/React.createElement(HeartStroke16, null),
    theme: "fill_secondary"
  }, isFavorite ? 'В избранном' : 'В избранное'));
});
FavoriteButton.displayName = 'FavoritesButton';